(function ($) {
  'use strict';

  $('.facet__item-header').click(function () {
    var $accordionToggle = $(this),
      $accordionText = $accordionToggle.siblings('.facet__item-content');

    if ($accordionToggle.hasClass('active')) {
      $accordionToggle.removeClass('active');
      $accordionText.slideUp(300, function () {
        $accordionText.removeClass('active').removeAttr('style');
      });
    } else {
      $accordionToggle.addClass('active');
      $accordionText.slideDown(300, function () {
        $accordionText.addClass('active').removeAttr('style');
      });
    }

    return false;
  });

  $('.facet__close, .facet__close-btn').click(function () {
    $('.facet__wrapper').removeClass('active');
  });

  $('.facet__mobile-btn').click(function () {
    $('.facet__wrapper').addClass('active');
  });

  $('.facet__show-more').click(function (e) {
    e.preventDefault();

    if ($(this).hasClass('active')) {
      $(this).parent().find('a:nth-child(n+9):not(:last-child)').addClass('hidden');
      $(this).removeClass('active');
      $(this).html('<span>Show more</span>');
    } else {
      $(this).parent().find('.hidden').removeClass('hidden');
      $(this).addClass('active');
      $(this).html('<span>Show less</span>');
    }
  });

  // Loop through each facet to determine if filters need to be opened
  $('.facet__item-content').each(function (index, facet) {
    // Loop through filters
    $(facet).find('a:not(.facet__show-more)').each(function (index, filter) {
      if (index > 7 && $(filter).hasClass('hidden active')) {
        $(facet).find('.facet__show-more').addClass('active').html('<span>Show less</span>');
        $(facet).find('a').removeClass('hidden');
      }
      return;
    });
    if ($(facet).find('.facet__show-more').hasClass('active')) {
      return;
    }
  });
}(jQuery));